<template>
    <digital-signature v-if="customerId && contractId"
        :customer-id="customerId"
        :contract-id="contractId"
        parent-component="validationRequestForm"
    ></digital-signature>
</template>

<script>
    import {mapState} from "vuex"
    import DigitalSignature from 'components/Customer/InformationsContent/Contracts/DigitalSignature'

    export default {
        data() {
            return {}
        },

        components: {
            DigitalSignature
        },

        computed:{
            ...mapState('demands', ['current_demands']),

            currentDemand() {
                return _.find(this.current_demands, (demand) => demand.id == this.$route.params.id)
            },

            contractId() {
                return this.currentDemand && this.currentDemand.validation_requestable.id
            },

            customerId() {
                return this.currentDemand && this.currentDemand.validation_requestable.customer_id
            }
        }
    }
</script>


// WEBPACK FOOTER //
// client/components/Demands/DigitalSignatureTab.vue